import React from 'react';
import PropTypes from 'prop-types';
import Header from './common/header';
import Footer from './common/footer';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { initState, initData } from '../actions';
import { DEFAULT_CONFIGURATOR_TYPE } from './../constants/configuratorType'; // eslint-disable-line


import { locale, configuratorType } from '../i18n.js';

const questions = function(){
  try{
    return require(`../data/${configuratorType}_questions${locale ? '_' + locale : ''}.json`);
  }catch(error){
    return require(`../data/${ configuratorType }_questions.json`);
    console.warn('Warning: using default questions config.', error); // eslint-disable-line no-console
  }
}();

const products = function(){
  try{
    return require(`../data/${ configuratorType }_products${locale ? '_' + locale : ''}.json`);
  }catch(error){
    console.log('error: ', error); // eslint-disable-line no-console
    return require(`../data/${ configuratorType }_products_en_gb.json`);
  }
}();

class App extends React.Component {
  constructor(props) {
    super(props);

    this.loadInitialState();
    
  }

  loadInitialState() {
    /* this became commented due to approval server 401 / basic auth probelmatic with ajax.
       Until this is fixed (eg. by using aws only) we should reuse it.

    const _loadQuestions = () => {
      return fetch('/it_it/showersystems/data/shower_questions.json')
        .then((response) => {
          return response.json();
        });
    };

    const _loadProducts = () => {
      return fetch('/it_it/showersystems/data/shower_products.json')
        .then((response) => {
          return response.json();
        });
    };

    _loadQuestions()
      .then((questions) => {
        this.props.actions.initState(
          questions
        );
      });
    
    _loadProducts().then((products) => {
      this.props.actions.initData({products});

    });
    */
    const { initData, initState } = this.props;

    initState(questions);
    initData({ products });
  }

  render() {
    return (
      <div>
        <Header />
        <main className="main">
          {this.props.children}
        </main>
        <Footer />
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.object.isRequired,
  configurator: PropTypes.object.isRequired,
  initState: PropTypes.func.isRequired,
  initData: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    data: state.data,
    configurator: state.configurator
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ initState, initData }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);



// WEBPACK FOOTER //
// ./src/components/App.js